export const SHIMMER_COLORS = {
  // Dark theme colors
  DARK_BASE: "#404040",
  DARK_HIGHLIGHT: "#525252",
  DARK_BACKGROUND: "#0D0E0F",

  // Light theme colors
  BASE: "#E5E5E5",
  HIGHLIGHT: "#F5F5F5",
} as const

export const BUNNY_VIDEO_PULL_ZONE_URL = "https://vz-55dbe737-8ac.b-cdn.net/"
